import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    icon: '📘',
    num: 'Tomo 1',
    title: 'Los Orígenes del Antiguo Egipto',
    desc: 'Cómo nació una de las civilizaciones más extraordinarias de la historia.'
  }, {
    icon: '👑',
    num: 'Tomo 2',
    title: 'Faraones que Cambiaron la Historia',
    desc: 'Los gobernantes que transformaron Egipto para siempre.'
  }, {
    icon: '☀️',
    num: 'Tomo 3',
    title: 'Dioses, Mitos y Religión del Antiguo Egipto',
    desc: 'Las creencias que dieron forma a toda una civilización.'
  }, {
    icon: '🏺',
    num: 'Tomo 4',
    title: 'La Vida Cotidiana del Antiguo Egipto',
    desc: 'Cómo vivían realmente sus habitantes.'
  }, {
    icon: '🔺',
    num: 'Tomo 5',
    title: 'Pirámides, Momias y los Grandes Misterios de Egipto',
    desc: 'Historia, arqueología y enigmas aún sin resolver.'
  }, {
    icon: '🌍',
    num: 'Tomo 6',
    title: 'El Legado del Antiguo Egipto',
    desc: 'La influencia de Egipto en el mundo antiguo y actual.'
  }];
  return <section className="py-20 md:py-32 px-4 relative" data-id="element-284">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-285" />

      <div className="max-w-6xl mx-auto" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-287">
          <div className="inline-block mb-4" data-id="element-288">
            <span className="text-gold text-4xl" data-id="element-289">🔺</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 text-white" data-id="element-290">
            ¿Qué incluye la colección Egipto Legendario?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16" data-id="element-291">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-8 rounded-xl hover:border-gold/40 transition-all group relative overflow-hidden" data-id="element-292">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-293" />

              <div className="flex items-center gap-3 mb-4" data-id="element-294">
                <span className="text-3xl" data-id="element-295">{tomo.icon}</span>
                <div className="text-gold font-bold text-sm tracking-widest uppercase" data-id="element-296">
                  {tomo.num}
                </div>
              </div>
              <h4 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-297">
                {tomo.title}
              </h4>
              <p className="text-gray-300 leading-relaxed relative z-10" data-id="element-298">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}